import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import logo from "../../../assets/img/DS.svg";
import { getStoredAdminInfo } from "../AdminAuth";

const BASE = "/stdcounciladmin/adminhome";

export default function CcSidebar() {
  const location = useLocation();

  const { isAudit, unitName } = getStoredAdminInfo();

  const unitLabel = unitName || "중앙운영위원회";

  const [openMenu, setOpenMenu] = useState({
    intro: false,
    board: false,
    data: false,
  });

  useEffect(() => {
    const path = location.pathname;

    setOpenMenu({
      intro: path.includes("/intro"),
      board: path.includes("/board"),
      data: path.includes("/data"),
    });
  }, [location.pathname]);

  const toggleMenu = (key) => {
    setOpenMenu((prev) =>
      Object.keys(prev).reduce((acc, k) => {
        acc[k] = k === key ? !prev[k] : false;
        return acc;
      }, {})
    );
  };

  const closeAllMenus = () => {
    setOpenMenu({
      intro: false,
      board: false,
      data: false,
    });
  };

  const isActive = (path) => location.pathname.includes(path);

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <div className="brand-left">
          <img
            src={logo}
            alt="덕성여대 총학생회 로고"
            className="sidebar-logo"
          />

          <div className="sidebar-title">
            <span>덕성여자대학교 총학생회</span>
            <span>홈페이지 관리</span>
          </div>
        </div>
      </div>

      <nav className="sidebar-nav">
        {isAudit ? (
          <>
            <div
              className={`sidebar-box clickable ${
                openMenu.data ? "is-open" : ""
              }`}
              onClick={() => toggleMenu("data")}
              aria-expanded={openMenu.data}
            >
              <span>자료실 관리</span>
              <span className={`arrow ${openMenu.data ? "is-open" : ""}`} />
            </div>

            {openMenu.data && (
              <div className="submenu">
                <NavLink
                  to={`${BASE}/data/audit-committee`}
                  className="submenu-item"
                >
                  <span
                    className={`dot ${
                      isActive("/data/audit-committee") ? "is-selected" : ""
                    }`}
                  />
                  <span className="submenu-text">감사위원회 자료</span>
                </NavLink>
              </div>
            )}

            <NavLink
              to={`${BASE}/account`}
              className={`sidebar-box ${isActive("/account") ? "active" : ""}`}
              onClick={closeAllMenus}
            >
              <span>내 계정 설정</span>
            </NavLink>
          </>
        ) : (
          <>
            <div
              className={`sidebar-box clickable ${
                openMenu.intro ? "is-open" : ""
              }`}
              onClick={() => toggleMenu("intro")}
              aria-expanded={openMenu.intro}
            >
              <span>소개 관리</span>
              <span className={`arrow ${openMenu.intro ? "is-open" : ""}`} />
            </div>

            {openMenu.intro && (
              <div className="submenu">
                <NavLink to={`${BASE}/intro`} className="submenu-item">
                  <span
                    className={`dot ${
                      isActive("/intro") ? "is-selected" : ""
                    }`}
                  />
                  <span className="submenu-text">{unitLabel}</span>
                </NavLink>
              </div>
            )}

            <div
              className={`sidebar-box clickable ${
                openMenu.board ? "is-open" : ""
              }`}
              onClick={() => toggleMenu("board")}
              aria-expanded={openMenu.board}
            >
              <span>조직별 관리</span>
              <span className={`arrow ${openMenu.board ? "is-open" : ""}`} />
            </div>

            {openMenu.board && (
              <div className="submenu">
                <NavLink to={`${BASE}/board`} className="submenu-item">
                  <span
                    className={`dot ${
                      isActive("/board") ? "is-selected" : ""
                    }`}
                  />
                  <span className="submenu-text">{unitLabel} 게시판 관리</span>
                </NavLink>
              </div>
            )}

            <NavLink
              to={`${BASE}/account`}
              className={`sidebar-box ${isActive("/account") ? "active" : ""}`}
              onClick={closeAllMenus}
            >
              <span>내 계정 설정</span>
            </NavLink>
          </>
        )}
      </nav>
    </aside>
  );
}